'use client';
import PageLoader from "@/components/layout/skeleton/PageLoader";

export default function Loading() {

  return (
    <PageLoader />
  );
}